module.exports = __webpack_public_path__ + "static/media/BlogMt.51fa4c18.svg";